import api from '@/api/api'
import {connectToWs, onMessage, onStatus, subscribe, unsubscribe} from '@/services/websocket'
import {isScene} from '@/common/mlbbOverlay'

export const BROADCAST_UPDATED_EVENT = 'mlbb-broadcast.updated'
export const broadcastChannel = (id) => `mlbb-broadcasts.${id}`

const SILENT = {skipErrorToast: true}

/** Ответ бэка → то, что выведено в эфир: {battleId, scene, postId}; пустая трансляция — сцена none */
export function programOf(raw) {
    const scene = isScene(raw?.scene) ? raw.scene : 'none'
    return {
        battleId: Number(raw?.battle_id) || null,
        scene,
        postId: scene === 'post' ? (Number(raw?.post_battle_id) || null) : null,
    }
}

/**
 * {battleId, scene, postId} → тело PATCH. Игру для итогов шлём только со сценой «Итоги»:
 * PATCH частичный, сохранённая post_battle_id остаётся до следующих итогов.
 */
export function programPayload({battleId, scene, postId}) {
    const body = {battle_id: battleId || null, scene}
    if (scene === 'post') body.post_battle_id = postId || null
    return body
}

/**
 * Трансляция: GET при старте и после реконнекта, дальше WS mlbb-broadcasts.{id} — каждый раз полный объект.
 *   onBroadcast(raw|null) — новое состояние (null — трансляции нет)
 *   onError(error)        — ошибка REST-загрузки (кроме 404)
 */
export function createBroadcastLive({broadcastId, onBroadcast, onError} = {}) {
    const channel = broadcastChannel(broadcastId)
    let stopped = false
    let loaded = false
    let offMessage = null
    let offStatus = null

    const emit = (raw) => {
        if (stopped) return
        onBroadcast && onBroadcast(raw || null)
    }

    async function load() {
        try {
            const res = await api.mlbbEsports.broadcast(broadcastId, SILENT)
            emit(res?.data?.data)
            loaded = true
        } catch (e) {
            if (e?.response?.status === 404) {
                emit(null)
                loaded = true
            } else if (!stopped) {
                onError && onError(e)
            }
        }
    }

    function handleMessage(msg) {
        // трансляции нет — сервер присылает массив строк с ошибкой
        if (stopped || !msg || Array.isArray(msg) || msg.event !== BROADCAST_UPDATED_EVENT) return
        if (msg.channel && msg.channel !== channel) return
        const raw = msg.data?.mlbb_broadcast
        if (raw && Number(raw.id) === Number(broadcastId)) emit(raw)
    }

    function handleStatus(status) {
        // пока сокета не было, режиссёр мог переключить сцену
        if (!stopped && status === 'open' && loaded) load()
    }

    return {
        channel,
        start() {
            offMessage = onMessage(handleMessage)
            offStatus = onStatus(handleStatus)
            connectToWs()
            subscribe(channel)
            return load()
        },
        refresh: load,
        stop() {
            stopped = true
            unsubscribe(channel)
            offMessage && offMessage()
            offStatus && offStatus()
        },
    }
}
